import { fetchWithRequestId } from '../../utils';
import { Logger } from './use-logger';

export class MiddlewareLogger implements Logger {
  private log(level: string, message: string | Error, details?: Record<string, unknown>): void {
    const line: Record<string, unknown> = {
      ...details,
      level,
      message: typeof message === 'string' ? message : message.message,
    };
    if (typeof message !== 'string') {
      line.stack = message.stack;
    }

    fetchWithRequestId()('/api/v1/logger', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(line),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(`Failed to post log message: ${response.status} ${response.statusText}`);
        }
      })
      .catch(() => console.error('Failed to post log message: Network error.'));
  }

  public debug(message: string, details?: Record<string, unknown>): void {
    this.log('debug', message, details);
  }

  public info(message: string, details?: Record<string, unknown>): void {
    this.log('info', message, details);
  }

  public warn(message: string | Error, details?: Record<string, unknown>): void {
    this.log('warn', message, details);
  }

  public error(message: string | Error, details?: Record<string, unknown>): void {
    this.log('error', message, details);
  }

  public fatal(message: string | Error, details?: Record<string, unknown>): void {
    this.log('fatal', message, details);
  }
}
